import script from "./EhTalkChat.vue?vue&type=script&setup=true&lang=js"
export * from "./EhTalkChat.vue?vue&type=script&setup=true&lang=js"

import "./EhTalkChat.vue?vue&type=style&index=0&id=5d95b9ea&scoped=true&lang=css"

import exportComponent from "/var/www/site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d95b9ea"]])

export default __exports__